<template>
  <div>
    <my-request-layout
      :workflowGuid="registration.workflowGuid"
      :foundRequest="!!registration"
      :isLoading="isLoading"
      :myRequest="registration"
      :cancelRequest="cancelRequest"
      :paymentStatus="paymentStatus"
      
      useAuthorizedPayment
      :makePayment="makePayment"
      :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
    >
      <span slot="title">QT Dog Registration Application</span>
      <div slot="requestContent" v-if="registration">
        <QTDogRegistrationRequest :registration="registration" />
        <div class="mt-5" v-if="!!registration">
          <h3>Co-Owners</h3>
          <CoownersList
            :owners="registration.owners"
            :ownershipType="dogOwnershipType"
            :hideHeader="true"
          />
        </div>
      </div>
    </my-request-layout>
    <v-snackbar v-model="showErrorMessage" title color="error">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
        Close
      </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import QTDogRegistrationRequest from "@/components/Portal/MyRequest/QTDogRegistrationRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

export default Vue.extend({
  name: "MyQTDogRequest",
  components: {
    MyRequestLayout,
    CoownersList,
    QTDogRegistrationRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getQTDogRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData | null) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitDogCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    dogOwnershipType: function () {
      return OwnershipType.Dog;
    },
  },
});
</script>
